import { LiveVideoRoomState } from '.';

const mutations = {
  setIsHLSStreamingSupported(store: LiveVideoRoomState, isSupported: boolean) {
    store.isHLSStreamingSupported = isSupported;
  },
  setIsHLSFragLoadError(state: LiveVideoRoomState, isError: Boolean) {
    state.isHLSFragLoadError = isError;
  },
  setIsHLSLevelLoadError(state: LiveVideoRoomState, isError: Boolean) {
    state.isHLSLevelLoadError = isError;
  },
  setIsHLSManifestLoadError(state: LiveVideoRoomState, isError: Boolean) {
    state.isHLSManifestLoadError = isError;
  },
  resetIsHLSFragLoadError(state: LiveVideoRoomState) {
    state.isHLSFragLoadError = false;
  },
  resetIsHLSLevelLoadError(state: LiveVideoRoomState) {
    state.isHLSLevelLoadError = false;
  },
  resetIsHLSManifestLoadError(state: LiveVideoRoomState) {
    state.isHLSManifestLoadError = false;
  }
};

export default mutations;
export type LiveVideoRoomMutations = typeof mutations;
